<template>
    <div class="add-image">
        <input style="display: none;" :title="language.add_image" type="file" accept="image/png, image/jpeg" class="form-control-file" :id="`popupfile-${slideid}`" v-on:change="getMediaFile">
        <i v-on:click.prevent="addImageToForm" class="fas fa-images"></i>
    </div>
</template>

<script>

import dataStore from "../../store";

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore: dataStore
        }
    },
    props: {
        slideid : Number,
    },
    computed: {},

    methods: {

        getMediaFile: function(e) {
            this.createImage(e.target.files[0]);
        },

        createImage(file) {

            let reader = new FileReader();
            let vm = this;

            reader.onload = (e) => {

                vm.dataStore.currentOpinion.image = {
                    file :  e.target.result,
                    name: file.name
                }

            };

            reader.readAsDataURL(file);
        },

        addImageToForm: function(type) {
            document.getElementById("popupfile-" + this.slideid).click();
        },

    }
};
</script>

